import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Link } from 'react-router-dom';
import { getWithdrawals, updateWithdrawal } from '../../actions/adminActions';
import { translateWithdrawalStatus } from '../../utils/translate';

import { forwardRef } from 'react';
import MaterialTable from "material-table";
import Grid from '@material-ui/core/Grid'
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { Checkbox, Switch, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

var panelStyle = { paddingLeft: '20px', paddingRight: '20px' }
var linkStyle = { color: "white" };

export const Withdrawals = () => {

    var columns = [{ title: "id", field: "id", hidden: true },
        { title: "User", field: "username", editable: 'never' },
        { title: "Paypal email", field: "paymentProviderEmail", editable: 'never' },
        { title: "Status", lookup: { 'REQUESTED': 'Requested', 'COMPLETE': 'Complete', 'DENIED': 'Denied', 'FAILED': 'Failed' },field: "status", render: rowData => translateWithdrawalStatus(rowData.status) },
        { title: "Reason", field: "reason" },
        // Custom render so we show the row's actual currency code (was hardcoded USD via Material-Table's type:'currency').
        { title: "Amount", field: "amount", editable: 'never', render: rowData => `${rowData.amount} ${rowData.currencyCode || 'USD'}` },
        { title: "Requested", editable: 'never', render: rowData => dateFormat(rowData.created) },
        { title: "Completed", editable: 'never', render: rowData => dateFormat(rowData.completed) },
        {
            title: "Link", editable: 'never', render: rowData => <Link className="table-button" to={'/users/' + rowData.userId}>View User</Link>
        },

    ];

    const dispatch = useDispatch();

    const { withdrawals, remoteHasError, remoteErrorMessages } = useSelector(state => ({
        withdrawals: state.adminReducer.withdrawals.withdrawals,
        remoteHasError: state.adminReducer.isError,
        remoteErrorMessages: state.adminReducer.errorMessages
    }), shallowEqual);

    const [isError, setIsError] = useState(remoteHasError)
    const [errorMessages, setErrorMessages] = useState(remoteErrorMessages)

    useEffect(() => {
        dispatch(getWithdrawals());
    }, ['All']); //Avoids infinite loop

    useEffect(() => {
        setIsError(remoteHasError);
    }, [remoteHasError]);

    useEffect(() => {
        setErrorMessages(remoteErrorMessages);
    }, [remoteErrorMessages]);

    const handleRowUpdate = (newData, oldData, resolve) => {
        console.log("newData=" + newData.status);
        console.log("oldData=" + oldData.status);
        let errorList = [];
      
        if (errorList.length < 1) {
            dispatch(updateWithdrawal(newData.id, newData.status, newData.reason));
        }
        else {
            setErrorMessages(errorList)
            setIsError(true)
        }
        resolve();
    }

    return (<div>
        <Grid container spacing={1}>

            <Grid item xs={10}>
                <div>
                    {isError &&
                        <Alert severity="error">
                            {errorMessages.map((msg, i) => {
                                return <div key={i}>{msg}</div>
                            })}
                        </Alert>
                    }
                </div>
                <MaterialTable
                    title="Withdrawals"
                    columns={columns}
                    data={withdrawals}
                    icons={tableIcons}
                    options={{
                        pageSize: 10,
                        pageSizeOptions: [20, 40],
                        toolbar: true,
                        paging: true,
                        search: false,
                    }}
                    editable={{
                        onRowUpdate: (newData, oldData) =>
                            new Promise((resolve) => {
                                handleRowUpdate(newData, oldData, resolve);
                            }),

                    }}
                />
            </Grid>
            <Grid item xs={3}></Grid>
        </Grid>
    </div>
        );
 }

function dateFormat(date) {

    if (typeof date === 'undefined')
        return "";

    var played = new Date(date);

    var formated = new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }).format(played)

    return formated;
}



